export const UPDATE_CONFIG_SUCCESS = 'UPDATE_CONFIG_SUCCESS';
export const SET_CURRENT_USER_SUCCESS = 'SET_CURRENT_USER_SUCCESS';
export const USER_LOGGED_OUT = 'USER_LOGGED_OUT';

export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const VALIDATE_RESET_TOKEN = 'VALIDATE_RESET_TOKEN';

export const USER_ACCEPT_TERMS_SUCCESS = 'USER_ACCEPT_TERMS_SUCCESS';

export const SET_CURRENT_ROLE = 'SET_CURRENT_ROLE';

export const SET_USER_IDLE = 'SET_USER_IDLE';

export const SET_DISPLAY_LOGOUT_WARNING_DIALOG = 'SET_DISPLAY_LOGOUT_WARNING_DIALOG';

export const SET_DISPLAY_LOGOUT_DIALOG = 'SET_DISPLAY_LOGOUT_DIALOG';



// WEBPACK FOOTER //
// ./src/auth/actionTypes.js